import React, { FC, memo } from "react";
import { RichText } from "@montana/shared/rich-text";
import { Media } from "@montana/shared/media";
import { IM06StoryBlock } from "@montana/models/generated/cms.interface";
import { epiMediaRatioToEnum } from "@montana/helpers/epi-mapping.helper";
import { extractCTALink } from "@montana/helpers/rich-text.helper";
import { Link } from "@montana/shared/link";

interface IStoryBlockSizes {
    [k: string]: string;
}

const mediaSizes: IStoryBlockSizes = {
    square: [
        '(min-width: 1680px) 510px',
        '(min-width: 1367px) 447px',
        '(min-width: 930px) 37vw',
        '(min-width: 811px) 500px',
        '(min-width: 415px) 323px',
        '78vw'
    ].join(', '),
    portrait: [
        '(min-width: 1680px) 416px',
        '(min-width: 1367px) 364px',
        '(min-width: 930px) 29vw',
        '(min-width: 811px) 376px',
        '(min-width: 415px) 250px',
        '60vw'
    ].join(', '),
    landscape: [
        '(min-width: 1680px) 640px',
        '(min-width: 1367px) 560px',
        '(min-width: 930px) 41vw',
        '(min-width: 811px) 547px',
        '(min-width: 415px) 366px',
        '92vw'
    ].join(', ')
}

export const M06StoryBlock: FC<IM06StoryBlock> = memo((props: IM06StoryBlock) => {
    const { backgroundColorHex, mediaDisplayRatio, video, image, content, contentAlignment } = props;

    const contentAlignClass = `story-block--content-${contentAlignment ?? 'right'}`
    const imageRatioClass = mediaDisplayRatio ? `story-block--${mediaDisplayRatio?.toLowerCase()}` : '';

    const sizes = mediaDisplayRatio && mediaSizes[mediaDisplayRatio]
        ? mediaSizes[mediaDisplayRatio]
        : '100vw';

    const RenderMedia = (): JSX.Element | null => {
        if (image) {
            return <Media image={image} mediaRatio={epiMediaRatioToEnum(mediaDisplayRatio)} sizes={sizes} placeholder />;
        } else if (video?.url) {
            return <Media video={video} mediaRatio={epiMediaRatioToEnum(mediaDisplayRatio || 'video')} placeholder />;
        }

        return null;
    }


    return (
        <section className={`story-block ${contentAlignClass} ${imageRatioClass}`}>
            <div className="story-block__text-block">
                {content && <RichText text={content} />}
            </div>
            <div className="story-block__media-block">
                <span className="story-block__media-bg" style={{ backgroundColor: backgroundColorHex }}></span>
                <Link className="story-block__media-wrapper" to={extractCTALink(content) || undefined}>
                    <RenderMedia />
                </Link>
            </div>
        </section>
    );
});
